import { Component, Input, OnInit, ViewChild, inject, input } from '@angular/core';
import { FiltersGroupModule } from '../filters/filters-group/filters-group.module';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDataGridComponent, DxDataGridModule, DxTextBoxModule } from 'devextreme-angular';
import { BookmarkNewComponent } from '../bookmark-new/bookmark-new.component';
import { HelpButtonComponent } from '../help-button/help-button.component';
import { BookmarkElementsOperator } from '../bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { ActivatedRoute, Data } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FiltersGroupBookmarkElementsOperator } from '../bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { UtilsService } from 'src/app/services/utils.service';
import { DxDataGridBookmarkElementsOperator } from '../bookmark-new/operators/elements-operators/dx-data-grid-bookmark-elements.operator';
import { FiltersOperator } from '../filters/api/filters-operator.api';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { MRPService } from 'src/app/pages/mrp/mrp.service';
import { TriToggleModule } from '../tri-toggle/tri-toggle.module';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { CellPreparedEvent, ContentReadyEvent,  ToolbarPreparingEvent } from 'devextreme/ui/data_grid_types';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { NotificationService } from 'src/app/services/notification.service';
import { ClickEvent } from 'devextreme/ui/button_types';
import { WindowService } from 'src/app/services/window.service';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { MRPOverviewPram } from 'src/app/models/mrp/mrp-overview-moels';
import { BookmarkPredefinedInstanceIdentifier } from 'src/app/enums/bookmark-predefined-instance-identifier.enum';
import { DDMrpStockStatus, DEFAULTS_TOKEN, Defaults } from 'src/app/app.defaults';
import { FitlersGroupPredefinedInstanceIdentifier } from 'src/app/enums/filters-group-predefined-instance-identifier.enum';
import { QueryFilterParameter } from '../filters/models/query-filter-parameter.model';
import { ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { WebExportModule } from '../web-export/web.export.module';


@Component({
    selector: 'app-replenishment-table',
    imports: [
        CommonModule,
        DxTableControllerDirective,
        FiltersGroupModule,
        BookmarkNewComponent,
        HelpButtonComponent,
        TriToggleModule,
        ContainerComponent,
        DxButtonModule,
        DxTextBoxModule,
        DxDataGridModule, WebExportModule
    ],
    templateUrl: './replenishment-table.component.html',
    styleUrl: './replenishment-table.component.scss',
	standalone: true
})
export class ReplenishmentTableComponent implements OnInit {

	@Input({ required: true })
	public filtersSelectionSetId!: SelectionSetId;
	@Input() showDataLoader: boolean = true;
	// public filtersBaseSelectStatementId!: BaseSelectStatementId;

	public defaults: Defaults = inject(DEFAULTS_TOKEN);

	protected filtersGroupInstanceIdentifier: number = FitlersGroupPredefinedInstanceIdentifier.ReplenishmentTable;
	protected bookmarkInstanceIdentifier: number = BookmarkPredefinedInstanceIdentifier.ReplenishmentTable;

	private _notificationService: NotificationService = inject(NotificationService);

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_GetMRPOverviewFiltersData,
				selectionSetId: async () => this.filtersSelectionSetId,
			}
		)
	);

	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	@ViewChild('dataGrid', { static: false })
	public dataGrid: DxDataGridComponent;

	public bookmarkElementsOperators: BookmarkElementsOperator[];

	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			),
			new DxDataGridBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxDataGridBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dataGrid
			),
		];

		return routeData;
	}

	// public tableDataOperator: TableDataOperator = new TableDataOperator(
	// 	new SelectStatementOptions(
	// 		{
	// 			filters: async () => this.pageFiltersOperator.appliedFilters,

	// 			baseSelectStatementId: BaseSelectStatementId.DEV_GetEsoSimulateMultiGridData,
	// 			selectionSetId: SelectionSetId.EsoSimulateMultiGrid
	// 		}
	// 	)
	// );

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						

						this.getData('reload');
					}
				}
			}
		);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public dxDataGridColumnAutoWidth: boolean = false;

	public changeDxDataGridColumnAutoWidthStatus() {
		this.dxDataGridColumnAutoWidth = !this.dxDataGridColumnAutoWidth;

		

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(
			(column) => {
				delete column.width;
			}
		);

		this.dataGrid.instance.state(currentState);
	}

	public dxDataGridHasActiveFilters: boolean = false;

	public changeActiveFiltersStatus() {
		if (this.dxDataGridHasActiveFilters) {
			this.dxDataGridHasActiveFilters = !this.dxDataGridHasActiveFilters;
			this.dataGrid.instance.clearFilter();
		}
	}

	public onToolbarPreparing(evt: ToolbarPreparingEvent) {
		const toolbarItems = evt.toolbarOptions.items;

		toolbarItems.unshift(
			{
				location: 'before',
				template: 'expandButtonTemplate'
			},
			{
				location: 'before',
				template: 'heightButtonTemplate'
			},
			{
				location: 'before',
				template: 'legendsTemplate'
			},
			{
				location: 'after',
				template: 'appliedFiltersButtonTemplate'
			}
		);
	}

	public onContentReady(evt: ContentReadyEvent) {
		const filter = evt.component.getCombinedFilter();

		if (filter) {
			this.dxDataGridHasActiveFilters = true;
		} else {
			this.dxDataGridHasActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-mrp-overview', JSON.stringify(this.dataGrid.instance.state()));
	}

	public onCellPrepared(evt: CellPreparedEvent) {
		evt.cellElement.style.padding = '5px';
	}
 
	private _mrpService: MRPService = inject(MRPService);
	private _windowService: WindowService = inject(WindowService);

	public periodValue?: string = '1';
	public periodType: string;

	public onLinkActionButtonClicked(evt: ClickEvent, data: any) {
		evt.event.stopPropagation();

		this._windowService.openInNewPage(
			"/mrp/deepdive",
			{
				id: data.data.ProductId,
			}
		);
	}

	public showActiveInactiveToggle: boolean = false;

	public activeInactive: number = 1;

	public activeInactiveToggleChange(item?: number) {
		this.activeInactive = item;
	}

	tableColumnsDataSource: any[] = [];
	tableColumnsCaptions: any[] = [];
	tableValuesDataSource: any[] = [];

	DynamicColumn: any[] = [];
	IsColumnLoaded: boolean = false;

	getData(action) {
		let dataObjectPram: MRPOverviewPram = new MRPOverviewPram();
		dataObjectPram.Action = action;
		dataObjectPram.filtersOptions = [];
		dataObjectPram.numofdays = this.periodValue;

		

		this.pageFiltersOperator.overviewFiltersOutput.filters.forEach(element => {
			let filterItem: QueryFilterParameter = new QueryFilterParameter(
				element.fieldName,
				element.value,
				element.operation
			);
			dataObjectPram.filtersOptions.push(filterItem);
		});

		this.showLoader();
			this._mrpService.SelectMrpOverviewData(dataObjectPram,{showLoadingIndicator:this.showDataLoader}).subscribe(resp => {
				this.hideLoader();
				if (resp) {
					this.tableValuesDataSource = resp[0];
					this.tableColumnsDataSource = resp[1];
					if (resp && resp[2]) {
						this.tableColumnsCaptions = resp[2];
					}
					console.log(this.tableColumnsCaptions);

					let DDMrpStatusFilterData: any[] = [];
					let FilterData = [];

					if (resp != null && resp != undefined && resp[0] != null) {
						FilterData = resp[0].map(item => item.DDMrpStockStatus).filter((value, index, self) => self.indexOf(value) === index);
					}

				if (FilterData != null && FilterData != undefined && FilterData.length > 0) {
					FilterData.forEach(
						element => {
							if (element < this.defaults.ddMrpStockStatuses.length) {
								let status: DDMrpStockStatus = this.defaults.ddMrpStockStatuses[element];

								if (status !== null && status.name !== null) {
									DDMrpStatusFilterData.push(
										{
											text: status.name,
											value: ['DDMrpStockStatus', '=', element]
										}
									);
								}
							} else {
								console.error(`ddMrpStockStatus under index ${element} doesn't not exit but you are trying to access it.`);
							}
						}
					);
				}

					if (!this.IsColumnLoaded) {
						this.DynamicColumn.push({
							alignment: 'left',
							type: "buttons", width: "135", cellTemplate: "actionTemplate",
							caption: 'Action'
						});

						this.tableColumnsDataSource.forEach(element => {
							let dataType = null;
							let DataFormate = null;

							if (this.tableColumnsCaptions) {
								let Selections = this.tableColumnsCaptions.filter(x => x["SelectionName"].toLowerCase() == element.FieldName.toLowerCase());
								if (Selections && Selections[0] && Selections[0]["DataType"]) {
									dataType = Selections[0]["DataType"];
								}
								if (Selections && Selections[0] && Selections[0]["DataTypeFormat"]) {
									DataFormate = Selections[0]["DataTypeFormat"];
								}
							}

							if (element.FieldName == 'DDMrpStockStatus') {
								this.DynamicColumn.push({
									alignment: 'left',
									width: "135", cellTemplate: "ddMrpStockStatusTemplate",
									dataField: element.FieldName,
									caption: element.Caption,
									format: DataFormate, dataType: dataType,
									allowFiltering: true, allowSorting: true,
									headerFilter: { dataSource: DDMrpStatusFilterData, filterRow: false }, filterRow: false
								});
							} else {
								this.DynamicColumn.push({
									alignment: 'left',
									dataField: element.FieldName,
									caption: element.Caption,
									format: DataFormate, dataType: dataType
								});
							}
						});
						this.IsColumnLoaded = true;
					}
				}
				this.hideLoader();
			},(error:any)=>this.hideLoader());
	}

	showLoader(): void {
		if (this.dataGrid && this.dataGrid.instance) {
			// Show the loading indicator
			this.dataGrid.instance.beginCustomLoading('Loading...');
		}
	}

	hideLoader(): void {
		if (this.dataGrid && this.dataGrid.instance) {
			// Hide the loading indicator
			this.dataGrid.instance.endCustomLoading();
		}
	}


	async ngOnInit(): Promise<void> {
		this._mrpService.getReplenishmentVendorList().subscribe(
			{
				next: (response) => {
					if (response) {
						this.periodType = "Number of " + response.periodTypelst[0].periodType;

						if (response.enableAcceptRejectMRP == "yes") {
							this.showActiveInactiveToggle = true;
						}
					}
				}
			}
		);

		this.pageFiltersOperator.onFiltersApplied.subscribe(
			(_) => {

				if (!this.periodValue || this.periodValue === '') {
					this._notificationService.error(`Please enter ${this.periodType}.`);
				} else {
					this.getData('reload');

					this.pageFiltersOperator.load(
						{
							showLoadingIndicator: true,
						}
					);

				
				}
			}
		);

		await this.initializeBookmarks();

		this.loadPageData();
	}

	ExportToExcelFilters: ExportFilter[] = [];
	// Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	  }

	  filterMappingService = new FilterMappingService();
}
